export default "__VITE_ASSET__CnhPl4oL__"